/* @flow */

import * as React from 'react';

const pickFromObject = (obj, keys) =>
  keys
    .map(key => (key in obj && obj[key] !== '' ? { [key]: obj[key] } : {}))
    .reduce((res, o) => Object.assign(res, o), {});

const SiteAddress = (props: Object): React.Element<*> => {
  const {
    address_1,
    address_2,
    address_3,
    address_4,
    address_5,
    country_name,
    postcode,
    siteName,
  } = props;

  const { fullAddress, singleLine } = formatSiteAddress(
    {
      address_1,
      address_2,
      address_3,
      address_4,
      address_5,
      country_name,
      postcode,
    },
    siteName
  );

  if (props.list) {
    return (
      <address>
        <ul>
          {siteName && <li>{siteName}</li>}
          <li>{fullAddress.address_1}</li>
          <li>{fullAddress.address_2}</li>
          <li>{fullAddress.address_3}</li>
          <li>{fullAddress.address_4}</li>
          <li>{fullAddress.address_5}</li>
          <li>{fullAddress.country_name}</li>
          <li>{fullAddress.postcode}</li>
        </ul>
      </address>
    );
  }

  return <span title={fullAddress}>{singleLine}</span>;
};

export default SiteAddress;

type SiteAddressType = {
  address_1: string,
  address_2: string,
  address_3: string,
  address_4: string,
  address_5: string,
  country_name: string,
  postcode: string,
};
export const formatSiteAddress = (address: SiteAddressType, siteName?: string) => {
  const fullAddress = pickFromObject(address, [
    'address_1',
    'address_2',
    'address_3',
    'address_4',
    'address_5',
    'country_name',
    'postcode',
  ]);

  const array = Object.values(fullAddress);

  if (siteName) {
    array.unshift(siteName);
  }

  const filteredArray = array.filter(part => !!part);

  return {
    fullAddress,
    filteredArray,
    singleLine: filteredArray.join(', '),
  };
};
